<template>
  <div class="fullHeight">
    <MypageSideMenu :memberDropClose="true"/>
    <Card
        :page_title="page_title"
        iconclass="icon-icon-reserve mypage-title-icon"
        :reserve_list_flg="true"
        >
      <!-- <div class="reseveTabletitle mb-3 font-weight-bold">予約状況一覧</div> -->
        <button
            class="btn btn-sm reserve_type"
            @click="changeReservesList(5)"
            :disabled="!selectReserveType1"
            :class="{
                'btn-outline-info': selectReserveType1,
                'btn-info': !selectReserveType1
            }"
        >予約</button>
        <button
            class="btn btn-sm reserve_type"
            @click="changeReservesList(6)"
            :disabled="!selectReserveType2"
            :class="{
                'btn-outline-info': selectReserveType2,
                'btn-info': !selectReserveType2
            }"
        >キャンセル</button>
        <button
            class="btn btn-sm reserve_type"
            @click="changeReservesList(7)"
            :disabled="!selectReserveType4"
            :class="{
                'btn-outline-info': selectReserveType4,
                'btn-info': !selectReserveType4
            }"
        >過去の<span class="sp_label"></span>履歴</button>
        <table class="table table-striped listTable">
            <thead class="sp_not">
            <tr>
                <th class="text-center width-120" scope="col">プレー日</th>
                <th class="text-center min-width-35" scope="col">スタート時間</th>
                <th class="text-center min-width-15" scope="col">プレースタイル</th>
                <th class="text-center width-60" scope="col">組数</th>
                <th class="text-center width-60" scope="col">人数</th>
                <th class="text-center width-120" scope="col">予約状況</th>
                <th class="text-center width-120" scope="col">同伴者登録・変更</th>
            </tr>
            </thead>
            <tbody>
                <template v-if="desserts.length === 0">
                    <tr>
                        <td colspan="8" class="text-center">予約がありません。</td>
                    </tr>
                </template>
                <template v-else>
                    <tr v-for="data in desserts" :key="data.id">
                        <td class="text-center max-width-35 d-flex justify-content-between d-reserve-list-table-cell">
                            <span class="sp_label text-left">プレー日</span>
                            <a @click="gotoReserveReference(data)" href="#">{{ data.play_date }}</a>
                        </td>
                        <td class="text-center d-flex justify-content-between d-reserve-list-table-cell">
                            <span class="sp_label">スタート時間</span>{{ data.play_start }}
                        </td>
                        <td class="max-width-15 d-flex justify-content-between d-reserve-list-table-cell">
                            <span class="sp_label">プレースタイル</span>
                            <Icon :iconFlg="data.play_style" :dispType="'playStyle'"/>
                        </td>
                        <td class="number-text d-flex justify-content-between d-reserve-list-table-cell">
                            <span class="sp_label">組数</span>{{ data.cell_number }}組
                        </td>
                        <td class="number-text d-flex justify-content-between d-reserve-list-table-cell">
                            <span class="sp_label">人数</span>{{ data.play_number }}人
                        </td>
                        <td class="text-center min-width-75 d-flex justify-content-between d-reserve-list-table-cell">
                            <span class="sp_label text-left">予約状況</span>{{ reserveSituationCode[data.reserve_situation] }}
                        </td>
                        <td class="min-width-75 btn-align d-flex justify-content-between d-reserve-list-table-cell">
                            <span class="sp_label">同伴者登録・変更</span>
                            <button
                                class="btn btn-outline-info btn-sm"
                                :disabled="data.reserve_situation === '3' ||
                                        data.reserve_situation === '4' ||
                                        data.reserve_type == 3 ||
                                        checkReserveMemberNo(data.member_no) ||
                                        playTogetherFixedDeadline(data)"
                                :class="{'btn-outline-secondary': data.reserve_situation === '3' ||
                                        data.reserve_situation === '4'}"
                                @click="OnUpdateCompanion(data)"
                                style="width: 75px;">変&nbsp;更
                            </button>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <nav aria-label="Page navigation" class="w-100">
            <ul class="pagination pagination-sm justify-content-center">
                <li class="page-item" @click="ClickPagination('Previous')">
                    <span class="btn btn-outline-info Mypagepoint_pagelinkwidth">前へ</span>
                </li>
                <li class="pagination-center">
                    <span>{{ pagination }} / {{ maxPaginationNotReturnZero }}</span>
                </li>
                <li class="page-item" @click="ClickPagination('Next')">
                    <span class="btn btn-outline-info Mypagepoint_pagelinkwidth">次へ</span>
                </li>
            </ul>
        </nav>
    </Card>
    <ConfirmDialog
        v-if="cancelDialog === true"
        initialMessage="この予約をキャンセルします。"
        doing="はい"
        notDoing="いいえ"
        :processing="processing"
        @from-Dialog="cancelReserve"
        @closeBtn="cancelOverlayHidden"
    />
  </div>
</template>

<script>
import MypageSideMenu from './MypageSideMenu';
import Card from '../components/Card';
import ConfirmDialog from '../components/ConfirmDialog';
import { GET_CODE_LIST } from '../../constants/codelist';
import {
    GET_MY_PAGE_RESERVES_LIST,
    CANCEL_RESERVE_FROM_MYPAGE,
    GET_MAX_RESERVE_BRANCH_NO } from '../../constants/mypage_reserves';
import { RESERVE_USE_POINT_CANCEL } from '../../constants/mypage_point';
import Icon from '../components/Icon';

export default {
    components: {
        MypageSideMenu,
        Card,
        ConfirmDialog,
        Icon
    },
    data () {
        return {
            // ページタイトル
            page_title: '予約状況一覧',
            // 現在ログインしているメンバーID
            memberNo: '',
            // キャンセル時に使用するID
            cancelData: {
              id: ''
            },
            // キャンセルダイアログの表示フラグ
            cancelDialog: '',
            // 処理の結果のオブジェクト
            processing: {
                result: '',
                resultText: '',
                btnDisabled: 0,
            },
            // 予約情報
            desserts: [],
            // CodeMasterからの取得値
            reserveSituationCode: {},
            // 表示中のページネーション番号
            pagination: 1,
            // 最大ページネーション数(初期表示)
            maxPagination: 1,
            // 一覧取得の開始値
            beginRow: 0,
            // 一覧の最大表示値
            limitRows: 10,
            // 現在の日付
            nowDate: null,
            // 昨日の日付
            yesterday: null,
            // 予約種別(初期表示は通常予約)
            reserve_type: 5,
            selectReserveType1: false,
            selectReserveType2: true,
            selectReserveType3: true,
            selectReserveType4: true,
        };
    },
    created () {
        this.memberNo = this.$store.state.auth.loginMember.member_no;
        this.getCodeList();
        this.getReservesList();
        this.getDateNow();
    },
    computed: {
        maxPaginationNotReturnZero () {
            return this.maxPagination === 0 ? 1 : this.maxPagination;
        }
    },
    methods: {
        /** ----------------------------------------------
         * ページネーション処理
         * ---------------------------------------------- */
        ClickPagination: async function (mode) {
            // 前へボタン押下時処理
            if (mode === 'Previous') {
                if (this.pagination > 1) {
                    this.pagination--;
                    if (this.display_pagination === 1) {
                        this.beginRow = 0;
                    } else {
                        this.beginRow = this.beginRow - this.limitRows;
                    }
                    await this.getReservesList();
                } else {
                    return;
                }
            } else {
                // 次へボタン押下時処理
                if (this.pagination < this.maxPagination) {
                    this.beginRow = this.beginRow + this.limitRows;
                    this.pagination++;
                    await this.getReservesList();
                } else {
                    return;
                }
            }
            window.scrollTo({ top: 0 });
        },
        /** ----------------------------------------------
         * 予約一覧を取得
         * ---------------------------------------------- */
        getReservesList () {
            this.$apollo.mutate({
                fetchPolicy: 'no-cache',
                mutation: GET_MY_PAGE_RESERVES_LIST,
                variables: {
                    member_no: this.memberNo,
                    reserve_type: this.reserve_type,
                    limit: this.limitRows,
                    offset: this.beginRow
                }
            }).then(res => {
                const data = res.data.GetReserveListByMyPage.ReserveList;
                const totalCount = res.data.GetReserveListByMyPage.count;
                this.maxPagination = Math.ceil(totalCount / this.limitRows);
                // 一度list内を空にする
                this.desserts.splice(0, this.desserts.length);
                data.forEach(el => {
                    this.desserts.push(el);
                });
            }).catch(error => {
                this.$set(this.processing, 'resultText', error);
            })
        },
        changeReservesList (reserveType) {
            this.pagination = 1;
            this.beginRow = 0;
            this.reserve_type = reserveType;
            switch (reserveType) {
                case 1, 5:
                    this.selectReserveType1 = false;
                    this.selectReserveType2 = true;
                    this.selectReserveType3 = true;
                    this.selectReserveType4 = true;
                    break;
                case 2:
                    this.selectReserveType1 = true;
                    this.selectReserveType2 = false;
                    this.selectReserveType3 = true;
                    this.selectReserveType4 = true;
                    break;
                case 3:
                    this.selectReserveType1 = true;
                    this.selectReserveType2 = true;
                    this.selectReserveType3 = false;
                    this.selectReserveType4 = true;
                    break;
                case 4, 7:
                    this.selectReserveType1 = true;
                    this.selectReserveType2 = true;
                    this.selectReserveType3 = true;
                    this.selectReserveType4 = false;
                    break;
                case 6:
                    this.selectReserveType1 = true;
                    this.selectReserveType2 = false;
                    this.selectReserveType3 = true;
                    this.selectReserveType4 = true;
                    break;
            }
            this.getReservesList();
        },
        /** ----------------------------------------------
         * キャンセル処理を表示
         * ---------------------------------------------- */
        cancelReserve: async function () {
            this.$store.commit("loading/setIsLoading", true);
            await this.$apollo.mutate({
                mutation: CANCEL_RESERVE_FROM_MYPAGE,
                variables: {
                    reserve_no: this.cancelData.id
                }
            }).then(res => {
                const result = res.data.cancelReserveFromWeb.result;
                if(result !== 0){
                   this.$set(this.processing, 'result', 1);
                   this.$set(this.processing, 'resultText', 'キャンセルが完了しました。');
                   this.cancelPoint();
                }else if (result === 0) {
                    throw res.data.errorMessage;
                    throw new Error(res.errorMessage);
                }
                this.cancelOverlayHidden();
                this.getReservesList();
            }).catch(error => {
                this.cancelOverlayHidden();
                this.getReservesList();
                this.$set(this.processing, 'resultText', error);
            });
            this.$store.commit("loading/setIsLoading", false);
        },
        /** ----------------------------------------------
         * ポイントキャンセル
         * ---------------------------------------------- */
        cancelPoint () {
            var data = [];
            let obj = {
                member_no: this.memberNo.toString(),
                golf_code: this.cancelData.golf_code,
                reserve_no: this.cancelData.id
            };
            data.push(obj);
            this.$apollo.mutate({
                mutation: RESERVE_USE_POINT_CANCEL,
                variables: {
                    CancelPointByMemberNo: data
                }
            });
        },
        /** ----------------------------------------------
         * キャンセルダイアログを表示
         * ---------------------------------------------- */
        cancelOverlayDisplay (data) {
            this.$set(this.cancelData, 'id', data.reserve_no);
            this.$set(this.cancelData, 'golf_code', data.golf_code);
            this.cancelDialog = !this.cancelDialog;
        },
        /** ----------------------------------------------
         * キャンセルダイアログを表示
         * ---------------------------------------------- */
        cancelOverlayHidden (data) {
          this.cancelDialog = !this.cancelDialog;
          this.$set(this.processing, 'result', '');
        },
        /** ----------------------------------------------
         * 予約状況詳細に遷移
         * ---------------------------------------------- */
        gotoReserveReference (data) {
            this.$store.commit("mypage/pushReserveNo", data.reserve_no);
            this.$store.commit('mypage/useGolfCode', data.golf_code);
            this.$router.push({ path: '/mypage-reserve-reference' });
        },
        /** ----------------------------------------------
         * お問い合わせページに遷移
         * ---------------------------------------------- */
        gotoInquiry (data) {
            this.$store.commit("mypage/pushReserveNo", data.reserve_no);
            this.$store.commit("mypage/pushPlanName", data.plan_name);
            this.$store.commit('mypage/useGolfCode', data.golf_code);
            this.$store.commit('mypage/pushPlayDate', data.play_date);
            this.$store.commit('mypage/useGolfName', data.golf_name);
            this.$router.push({ path: '/mypage-reserve-contact' });
        },
        /** ----------------------------------------------
         * 予約状況変更に遷移
         * クラシックでは使用しない
         * ---------------------------------------------- */
        // gotoReserveUpdate (data) {
        //     this.$store.commit("mypage/pushReserveNo", data.reserve_no);
        //     this.$store.commit('mypage/useGolfCode', data.golf_code);
        //     this.$router.push({ path: '/mypage-reserve-update' });
        // },
        /** ----------------------------------------------
         * 予約状況オブジェクトを取得
         * ---------------------------------------------- */
        getCodeList () {
            this.$apollo.query({
                query: GET_CODE_LIST,
                variables: {
                    code_key: 'reserve_situation',
                    default_display: 0
                }
            }).then(res => {
                const data = res.data.GetCodeList.CodeList;
                data.forEach(el => {
                    this.reserveSituationCode[String(el.code)] = el.code_name;
                });
            });
        },
        /** ----------------------------------------------
         * 現在日付の取得
         * ---------------------------------------------- */
        getDateNow () {
            var NowDate = new Date();
            this.nowDate = NowDate.getFullYear() + '-' + ('0' + (NowDate.getMonth() + 1)).slice(-2) + '-' + ('0' + NowDate.getDate()).slice(-2);
            this.yesterday = NowDate.getFullYear() + '-' + ('0' + (NowDate.getMonth() + 1)).slice(-2) + '-' + ('0' + (NowDate.getDate() - 1)).slice(-2);
        },
        /** ----------------------------------------------
         * 日付の確認
         * 現在の日付よりプレー日が当日以前だったらtrueを返す
         * @playDate プレー日
         * ---------------------------------------------- */
        checkDate (playDate) {
            var me = this;
            var nowDate = Number(me.nowDate.replace(/-/g, ''));
            playDate = Number(playDate.replace(/-/g, ''));
            if (playDate < nowDate) {
                return true;
            } else {
                return false;
            }
        },
        /** ----------------------------------------------
         * 過去日付けの確認
         * 現在の日付よりプレー日が昨日だったらcssを切り替える
         * @playDate プレー日
         * ---------------------------------------------- */
        checkPastDateCssChange (playDate) {
            var me = this;
            var yesterday = Number(me.yesterday.replace(/-/g, ''));
            var playDate = Number(playDate.replace(/-/g, ''));
            if (yesterday >= playDate) {
                return 'yesterday';
            } else {
                return 'no_yesterday';
            }
        },
        /** ----------------------------------------------
         * 予約者の確認
         * 予約者とログインユーザーのmember_noが異なればtrueを返す
         * @memberNo 予約者のmember_no
         * ---------------------------------------------- */
        checkReserveMemberNo (memberNo) {
            var me = this;
            if (me.memberNo != memberNo) {
                return true;
            } else {
                return false;
            }
        },
        /** ----------------------------------------------
         * 同伴者の変更締め切りの確認
         * 設定された締め切り日の当日以降であればtrueを返す
         * @data 予約のデータ
         * ---------------------------------------------- */
        playTogetherFixedDeadline: function (data) {
            // 99は期限なしなので処理終わり
            if (data.play_together_fixed_deadline == 99) {
                return false;
            }
            const today = new Date();
            const playDate = new Date(data.play_date);
            const playDateYear = playDate.getFullYear();
            let playDateMonth = playDate.getMonth() + 1;
            let playDateDate = playDate.getDate();
            var limitDay = new Date(playDateYear, playDateMonth - 1, playDateDate - data.play_together_fixed_deadline);
            if (today >= limitDay) {
                return true;
            } else {
                return false;
            }
        },
        /** ----------------------------------------------
         * 同伴者登録画面表示（同伴者変更及び人数変更）
         * ---------------------------------------------- */
        OnUpdateCompanion: async function(data) {
            await this.checkMaxReserveBranchNo(data.reserve_no);
            sessionStorage.setItem('MyPage.reserveNo', data.reserve_no);
            sessionStorage.setItem('Reserve.reserveNo', data.reserve_no);
            sessionStorage.setItem('Reserve.PlayerNumber', data.play_number);
            sessionStorage.setItem('Reserve.reserveType','1');
            sessionStorage.setItem('MyPage.returnBackUrl', "/mypage-reserve-list");
            //sessionStorage.setItem('MyPage.reserveNumber', Number(playNumber));
            // マイページ人数選択画面からの変更の場合
            sessionStorage.setItem('MyPage.companionChangeFlg', 1);
            this.$router.push({ path: "/companion-list" });
        },
        /** ----------------------------------------------
         * 最大の予約枝番を取得
         * ---------------------------------------------- */
        checkMaxReserveBranchNo: async function (reserveNo) {
            try {
                let res = await this.$apollo.query({
                    fetchPolicy: 'no-cache',
                    query: GET_MAX_RESERVE_BRANCH_NO,
                    variables: {
                        reserve_no: reserveNo
                    }
                });
                const data = res.data.GetReserveBranchNo.reserve_branch_no;
                sessionStorage.setItem("MyPage.reserveBranchNo", data);
            } catch (error) {
                this.error = error;
            }
        }
    }
}

</script>

<style scoped>
a{
    text-decoration: underline;
}
.table td{
    vertical-align: inherit;
    padding: 7px;
}
.yesterday{
    background-color: #dee2e6 !important;
}
.no_yesterday {
    background-color:#ffffff;
}
.reserve_type {
    width: 120px;
}
@media screen and (min-width: 896px) {
    .d-reserve-list-table-cell{
        display: table-cell !important;
    }
}
@media screen and (max-width: 896px) {
  .max-width-35{
      max-width: initial;
  }
  .max-width-50{
      max-width: initial;
  }
  .max-width-15{
      max-width: initial;
  }
  .max-width-1{
      max-width: initial;
  }
  .reserve_type {
      width: 115px;
      height: 3rem;
      font-size: 0.85rem;
      padding: 2px;
      line-height: 0.6rem;
  }
}
@media screen and (max-width: 575px) {
  .reserve_type {
      width: 23.6%;
      height: 3rem;
      font-size: 0.85rem;
      padding: 1px;
      line-height: 0.6rem;
  }
  .sp_btn {
      font-size: 0.73rem;
  }
}
</style>
